module.exports = __webpack_public_path__ + "066d09f15b29bf2113d7fa4153250411.jpg";